import { STRING_getInstance2ou4lro9xn2qn as STRING_getInstance } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import { PrimitiveSerialDescriptor3egfp53lutxj2 as PrimitiveSerialDescriptor } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialDescriptors.mjs';
import {
  Companion_getInstance3vhybkmm49bju as Companion_getInstance,
  LocalTime22kisvxz6f9p4 as LocalTime,
} from '../LocalTime.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var LocalTimeIso8601SerializerClass;
function LocalTimeIso8601Serializer() {
  if (LocalTimeIso8601SerializerClass === VOID) {
    class $ {
      constructor() {
        LocalTimeIso8601Serializer_instance = this;
        this.u25_1 = PrimitiveSerialDescriptor('kotlinx.datetime.LocalTime', STRING_getInstance());
      }
      az() {
        return this.u25_1;
      }
      pz(decoder) {
        return Companion_getInstance().x25(decoder.h13());
      }
      y25(encoder, value) {
        encoder.p14(value.toString());
      }
      oz(encoder, value) {
        return this.y25(encoder, value instanceof LocalTime() ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'LocalTimeIso8601Serializer', VOID, VOID, [KSerializer()]);
    LocalTimeIso8601SerializerClass = $;
  }
  return LocalTimeIso8601SerializerClass;
}
var LocalTimeIso8601Serializer_instance;
function LocalTimeIso8601Serializer_getInstance() {
  if (LocalTimeIso8601Serializer_instance === VOID)
    new (LocalTimeIso8601Serializer())();
  return LocalTimeIso8601Serializer_instance;
}
//region block: exports
export {
  LocalTimeIso8601Serializer_getInstance as LocalTimeIso8601Serializer_getInstance1gy7xllc2odvq,
};
//endregion

//# sourceMappingURL=LocalTimeSerializers.mjs.map
